import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["SubjectReconciliation"],
});

const subjectReconciliationApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getSubjectReconciliation: builder.query({
      query: ({ classroom_id, session_id }) =>
        `/subject/reconciliation?classroom_id=${classroom_id}&session_id=${session_id}`,
      providesTags: ["SubjectReconciliation"],
    }),
    reconcileSubjectRecords: builder.mutation({
      query: (body) => ({
        url: "/subject/reconcile",
        method: "POST",
        body,
      }),
      invalidatesTags: ["SubjectReconciliation"],
    }),
  }),
});

export const {
  useGetSubjectReconciliationQuery,
  useLazyGetSubjectReconciliationQuery,
  useReconcileSubjectRecordsMutation,
} = subjectReconciliationApiSlice;
